const PARENT_CL_ALLOWANCE = 2;

const getAttendanceTypes = (attendance) =>
  Array.isArray(attendance?.type)
    ? attendance.type
    : attendance?.type
    ? [attendance.type]
    : [];

const isParentLeaveAttendance = (attendance) => {
  if (!attendance || attendance.isDeleted || attendance.earlyAttendance) return false;

  const types = getAttendanceTypes(attendance);
  if (!types.includes("ABSENT")) return false;

  const leaveFor = String(attendance.recoveryFor || attendance.leaveFor || "")
    .trim()
    .toUpperCase();

  return leaveFor === "PARENT";
};

const hasDecisiveLeaveStatus = (attendance) =>
  attendance?.counted === true || attendance?.notCounted === true;

const getUtcMonthKey = (attendance) => {
  const date = new Date(attendance?.attendanceTime || attendance?.startTime);
  if (Number.isNaN(date.getTime())) return null;

  return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
};

// Parent gets 2 casual leaves each month. Leave count is the parent leaves left after those 2.
export const countParentLeavesAfterAllowance = (attendances = []) => {
  const parentLeaves = (attendances || []).filter(isParentLeaveAttendance);
  if (parentLeaves.length === 0) return 0;

  if (parentLeaves.every(hasDecisiveLeaveStatus)) {
    return parentLeaves.filter((attendance) => attendance.counted === true).length;
  }

  const leavesByMonth = new Map();
  parentLeaves.forEach((attendance) => {
    const monthKey = getUtcMonthKey(attendance);
    if (!monthKey) return;
    leavesByMonth.set(monthKey, (leavesByMonth.get(monthKey) || 0) + 1);
  });

  let leaveCount = 0;
  leavesByMonth.forEach((count) => {
    leaveCount += Math.max(0, count - PARENT_CL_ALLOWANCE);
  });

  return leaveCount;
};
